import { useState } from 'react';
import SubscribedLatestEpisodes from './SubscribedLatestEpisodes';
import LibrarySuggestions from './LibrarySuggestions';

// Keep the feed in place while people choose several suggestions. Successful
// saves still invalidate the cache; reloading the page or the next visit applies it.
export default function LibraryFollowing() {
    const [edits, setEdits] = useState({ pending: 0, changed: false });
    const onPreferenceSaveStart = () => {
        setEdits(value => ({ ...value, pending: value.pending + 1 }));
    };
    const onPreferenceSaveComplete = succeeded => {
        setEdits(value => ({ pending: Math.max(0, value.pending - 1), changed: value.changed || succeeded }));
    };

    return (
        <>
            <SubscribedLatestEpisodes
                deferAutomaticRefresh={edits.pending > 0 || edits.changed}
                followSavesPending={edits.pending > 0}
            />
            <LibrarySuggestions
                onPreferenceSaveStart={onPreferenceSaveStart}
                onPreferenceSaveComplete={onPreferenceSaveComplete}
            />
        </>
    );
}
